<template>
  <v-container fluid right class="text-center v-center">
    <v-img :src="image"/>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    image: require('@/assets/logo.png')
  })
}
</script>

<style scoped>
  .v-center {
    padding: 30px;
  }
</style>
